import React, { Component } from 'react'
import '../../css/CartaProducto.css'
import '../../css/scrollBar.css'


export default class ItemCardMin extends Component {

    selectItem(item){
        const Padre = this.props.Padre
        Padre.setState({selectedItem: item})
    } 

    render() {
        const isSelected = this.props.Padre.state.selectedActiveProducts.some(
            p => p.itemCode === this.props.ItemCode
        );

        return (
            <div className={`card cartaHover font-family-arial ${isSelected ? 'selected-product' : ''}`} onClick={() => this.selectItem(this.props.objectProd)}>
                <div className="card-body text-center">
                    <div className="col-12 imgC d-flex align-items-center justify-content-center">
                        <img key={this.props.itemURLImage} src={this.props.itemURLImage ? `${this.props.itemURLImage}` : "./assets/notavailable.png"} alt="Card cap" className='imgC' />
                    </div>
                    <p><span className="badge darkPurpleBackground mt-2 px-4">{this.props.ItemCode}</span></p>

                    <p className="card-text fs-6" style={{ minHeight: 75 }}>{this.props.Description}</p>
                </div>
            </div>
        )

    }
}


